/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const edit_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m21.74 7.394.414-.415a3.639 3.639 0 0 0 .035-5.169 3.64 3.64 0 0 0-5.17.035l-.414.415L2.52 16.345.75 23.25l6.905-1.771L21.739 7.394Zm-19.22 8.95 5.135 5.135M21.739 7.394 16.605 2.26"
    />
  </svg>
)
export default edit_medium
